import { createContext } from "react";

import { RouteType, routes } from "../constants";

export const RouteContext = createContext({
	route: routes.presentation as RouteType,
});

export const RouteProvider = ({
	children,
	route,
}: {
	children: any;
	route: RouteType;
}) => (
	<RouteContext.Provider value={{ route }}>{children}</RouteContext.Provider>
);
